<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(save)">
                      <div class="form-row">
                        <div class="form-group col-md-3">
                          <ValidationProvider
                              name="Plate End"
                              rules="required"
                              v-slot="{ errors }"
                          >
                            <label for="plate_end">
                              <span class="required">*</span>
                              {{ $t("Plate End") }}:
                            </label>
                            <b-form-input
                                type="number"
                                min="0"
                                max="9"
                                step="1"
                                id="license_plate"
                                v-model.number="vehicle_licensing_months.plate_end"
                                :state="errors.length ? false : null"
                                placeholder=""
                            />
                            <b-form-invalid-feedback>{{
                                $t(errors[0])
                              }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="form-group col-md-3">
                          <ValidationProvider
                              name="Licensing Month"
                              rules="required"
                              v-slot="{ errors }"
                          >
                            <label for="licensing_month">
                              <span class="required">*</span>
                              {{ $t("Licensing Month") }}:
                            </label>
                            <b-form-input
                                type="number"
                                min="0"
                                max="12"
                                step="1"
                                id="licensing_month"
                                v-model="vehicle_licensing_months.licensing_month"
                                :state="errors.length ? false : null"
                                placeholder=""
                            />
                            <b-form-invalid-feedback>{{
                                $t(errors[0])
                              }}
                            </b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                        <div class="form-group col-md-4">
                          <ValidationProvider
                              name="Vehicle Type"
                              rules="required"
                              v-slot="{ errors }"
                          >
                            <label for="vehicle_types">
                              <span class="required">*</span>
                              {{ $t("Vehicle Type") }}:
                            </label>
                            <v-select
                                :options="vehicle_types"
                                :reduce="(vehicle_types) => vehicle_types.id"
                                :label="'name'"
                                v-model="vehicle_licensing_months.vehicle_type_id"
                                class="vselect"
                                :class="{ 'is-invalid': errors.length }"
                            />
                            <span class="invalid-feedback">{{
                                $t(errors[0])
                              }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div class="required_fields">
                        <span class="required">*</span>
                        <strong> {{ $t('Required Fields') }}</strong>
                      </div>
                      <div class="block text-right">
                        <b-button variant="outline-secondary" class="btn btn-back" @click="$router.go(-1)">
                          <i class="fa fa-arrow-left"></i> {{ $t('To Go Back') }}
                        </b-button>

                        <b-button type="submit" variant="primary" class="ml-1">
                          {{ $t('Save') }}
                          <i class="fa fa-save"></i>
                        </b-button>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider, extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import BaseCrud from "../../layouts/Base/BaseCrud";
import UploadFile from "../../layouts/components/UploadFile";
import {BButton, BFormInput, BFormInvalidFeedback} from "bootstrap-vue";
import vehicle_licensing_months from "@/router/vehicle_licensing_months";
import axios from "axios";

extend("required", {
  ...required,
  message: "This field is required"
});

export default {
  data() {
    return {
      vehicle_licensing_months: {
        plate_end: '',
        licensing_month: '',
      },
      vehicle_types: [],
      errors: undefined,
      previewImage: null,
    };
  },
  methods: {
    save() {
      const self = this;
      let api = self.$store.state.api + "vehicle_licensing_months";

      if (self.vehicle_licensing_months.id) {
        self.vehicle_licensing_months._method = "PUT";
        api += "/" + self.vehicle_licensing_months.id;
      }

      axios
          .post(api, self.vehicle_licensing_months)
          .then(() => {
            self.$message(
                this.$t('Success'),
                this.$t('Information saved successfully'),
                "success"
            );
            this.$router.push("/vehicle_licensing_months");
          })
          .catch((error) => {
            this.$error(error);
          });
    },

    getVehicleLicensingMonths(id) {
      const self = this;
      const api = self.$store.state.api + "vehicle_licensing_months/" + id;

      axios
          .get(api)
          .then(response => {
            self.vehicle_licensing_months = response.data.data[0];
          })
          .catch(error => {
            this.$error(error);
          });
    },
    getVehicleTypes: function () {
      const self = this;
      const api = self.$store.state.api + "vehicle_types/";

      axios
          .get(api)
          .then((response) => {
            self.vehicle_types = response.data.data;
          })
          .catch((error) => {
            this.$error(error);
          });
    },
  },
  mounted() {
    const self = this;
    let id = self.$route.params.id;

    self.getVehicleTypes();

    if (id) {
      self.getVehicleLicensingMonths(id);
    }
  },
  components: {
    BButton,
    BFormInvalidFeedback, BFormInput,
    BaseCrud,
    UploadFile,
    ValidationObserver,
    ValidationProvider
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
    